module.exports = __webpack_public_path__ + "img/youtb.829b7135.png";